import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const NotificationSettings = () => {
  const [cats, setCats] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [cat, setCat] = useState("booking_paid");
  const [hubId, setHubId] = useState("");
  const [preview, setPreview] = useState(null);
  const [log, setLog] = useState(null);
  const [testTo, setTestTo] = useState("");

  useEffect(() => {
    api.get("/notification-categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/branches").then((r) => setHubs(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    api.get("/notification-routing", { params: { category: cat, hub_id: hubId || undefined } })
      .then((r) => setPreview(r.data)).catch(() => setPreview(null));
  }, [cat, hubId]);

  const loadLog = () => api.get("/email-log", { params: { limit: 20 } })
    .then((r) => setLog(r.data)).catch((e) => toast.error(e?.response?.data?.detail || "Gagal"));

  const sendTest = async () => {
    try {
      const r = await api.post("/notifications/test-email", { to: testTo || undefined });
      toast.success(r.data.queued ? `Email uji diantrikan ke ${r.data.to}` : "Tidak ada yang diantrikan");
      loadLog();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal mengirim email uji"); }
  };

  return (
    <section className="bg-white border border-black/10 rounded-lg p-5" data-testid="notif-settings">
      <h2 className="text-base font-semibold">Notifikasi Operasional</h2>
      <p className="mt-1 text-xs text-ink-soft">
        Penerima ditentukan dari peran + Hub yang ditugaskan ke akun staf (Staff Accounts), bukan dari
        nama Hub — mengganti nama Hub tidak pernah mengubah rute notifikasi. Kategori penting selalu
        terkirim walau staf mematikan kategori lain.
      </p>

      <div className="mt-4 grid sm:grid-cols-2 gap-3">
        <label className="block">
          <span className="text-[11px] uppercase tracking-widest text-ink-soft">Kategori</span>
          <select data-testid="notif-routing-category" value={cat} onChange={(e) => setCat(e.target.value)}
            className="mt-1 w-full h-10 rounded-md border border-input bg-white px-2 text-sm">
            {cats.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
          </select>
        </label>
        <label className="block">
          <span className="text-[11px] uppercase tracking-widest text-ink-soft">Hub</span>
          <select data-testid="notif-routing-hub" value={hubId} onChange={(e) => setHubId(e.target.value)}
            className="mt-1 w-full h-10 rounded-md border border-input bg-white px-2 text-sm">
            <option value="">Semua Hub</option>
            {hubs.map((h) => <option key={h.id} value={h.id}>{h.name}</option>)}
          </select>
        </label>
      </div>

      {preview && (
        <div className="mt-3 border border-black/10 rounded-md p-3" data-testid="notif-routing-result">
          <div className="text-xs text-ink-soft">
            {preview.recipients.length} penerima untuk “{preview.label}”
            {preview.hub_name ? ` di ${preview.hub_name}` : ""}
          </div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {preview.recipients.map((r) => (
              <span key={r.email} data-testid={`notif-recipient-${r.email}`}
                className="text-[11px] px-2 py-1 rounded-full border border-black/15">
                {r.email} · {r.role}{r.digest ? " · ringkasan pagi" : ""}
                {r.email_enabled ? "" : " · email mati"}
              </span>
            ))}
          </div>
          {(preview.warnings || []).map((w) => (
            <div key={w} className="mt-2 text-[11px] text-lm-red" data-testid="notif-routing-warning">{w}</div>
          ))}
        </div>
      )}

      <div className="mt-4 flex flex-wrap items-end gap-2">
        <label className="block flex-1 min-w-[220px]">
          <span className="text-[11px] uppercase tracking-widest text-ink-soft">Kirim email uji ke</span>
          <Input data-testid="notif-test-email-input" className="mt-1" placeholder="kosong = email saya"
            value={testTo} onChange={(e) => setTestTo(e.target.value)} />
        </label>
        <button data-testid="notif-test-email-btn" onClick={sendTest}
          className="lm-btn-primary rounded-md px-4 py-2.5 text-sm font-semibold">Kirim Email Uji</button>
        <button data-testid="notif-email-log-btn" onClick={loadLog}
          className="rounded-md border border-black/15 px-4 py-2.5 text-sm">Lihat Log Email</button>
      </div>

      {log && (
        <div className="mt-4" data-testid="notif-email-log">
          <div className="text-xs text-ink-soft">
            {log.configured ? "Email aktif" : "Email belum terkonfigurasi"} · menunggu {log.counts.pending} ·
            terkirim {log.counts.sent} · gagal {log.counts.failed} · dilewati {log.counts.skipped}
          </div>
          <div className="mt-2 overflow-x-auto">
            <table className="w-full text-xs">
              <thead className="text-left text-[10px] uppercase tracking-widest text-ink-soft">
                <tr><th className="py-2">Ke</th><th className="py-2">Subjek</th>
                  <th className="py-2">Kategori</th><th className="py-2">Status</th></tr>
              </thead>
              <tbody className="divide-y divide-black/5">
                {log.rows.map((r) => (
                  <tr key={r.id} data-testid={`email-log-${r.id}`}>
                    <td className="py-2">{r.to}</td>
                    <td className="py-2 max-w-[280px] truncate">{r.subject}</td>
                    <td className="py-2">{r.category}</td>
                    <td className="py-2">{r.status}{r.last_error ? ` · ${r.last_error}` : ""}</td>
                  </tr>
                ))}
                {log.rows.length === 0 && (
                  <tr><td colSpan={4} className="py-3 text-ink-soft">Belum ada email.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
};
